/* global Ladda */
(function ($) {
    'use strict';
    $.widget("fd.control_form", {
        options: {
            parentid: null,
            callback: function () { },
            onchange: true,         // If true, the form will submit on any :input change (input, textarea, button, or select)
            changecallback: null,   // If no change callback is provided, control will automatically pass to the submit callback
            dirtyformsmessage: 'You have unsaved changes that may be lost if you leave this page. Are you sure you wish to proceed?',
            dirtyformstitle: 'Unsaved Changes'
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            if (this.element.is('form')) {
                $.validator.unobtrusive.parse(this.element);
                const validator = this.element.data("validator");
                if (validator) {
                    validator.settings.ignore = ".select2-search__field,.ignore-validators";
                    validator.settings.focusInvalid = false;
                }
                // Custom scrolling on invalid form to support header overlay and hidden elements.
                $("form").bind("invalid-form.validate", function (event, validator) {
                    let target = $(validator.errorList[0].element).is('.picker__input') ?
                        $(validator.errorList[0].element).siblings('input').closest(":visible")
                        : $(validator.errorList[0].element).closest(":visible");

                    if (!validator.numberOfInvalids()) {
                        return;
                    }

                    const controlOffset = 35;
                    const scrollTo = target.offset().top
                        - parseInt($('.page-content').css('padding-top'))
                        - parseInt($('body').css('padding-top'))
                        - controlOffset;
                    if ($('html,body').scrollTop() > scrollTo) {
                        $('html,body').scrollTop(scrollTo);
                    }
                    target.focus();
                });

                this.form = this.element;
            } else {
                this.form = $("<form class='d-none'></form>").appendTo(this.element);
            }

            const dirtyFormOptions = {
                message: this.options.dirtyformsmessage,
                dialog: {
                    title: this.options.dirtyformstitle
                },
                fieldSelector: "input:not([type='button'],[type='image'],[type='submit'],[type='reset'],[type='search']),select,textarea",
                helpers: [
                    {
                        isDirty: function ($node, index) {
                            if ($node.is('form')) {
                                return $node.hasClass('force-dirty');
                            }
                        }
                    }
                ]
            };

            this.form.dirtyForms(dirtyFormOptions);

            this._setEvents();
        },
        _handleChange: function (event) {
            event.stopPropagation();
            const form = event.data;
            const $input = $(this);

            if ($input.is(":focus")) {
                $input.off('blur').on('blur', null, event.data, form._handleChange);
                return; // don't fire change event until the input loses focus
            }

            if (form.options.onchange) {
                if (form.options.changecallback && typeof (form.options.changecallback) === 'function') {
                    form.options.changecallback.call(form, { parentid: form.options.parentid, elem: $input }, event);
                }
                form.element.submit();
            }
            if (!form.element.is('form')) {
                form.form.addClass('dirty');
            }
        },
        _handleSubmit: function (event) {
            const self = event.data;
            if (self._triggerElement === undefined) {
                self._triggerElement = event.originalEvent ? $(event.originalEvent.submitter) : null;
            }
            self.options.callback.call(self, { parentid: self.options.parentid }, event);

            // An unobtrusive form will post on its own so don't cancel the event.
            if (!self.element.data('ajax')) {
                event.stopPropagation();
            }
            // Ignore dirty bit if this is submiting as a standard form.
            if (!self.element.data('ajax') && self.element.attr('action')) {
                self.setClean();
            }
        },
        _handleReset: function (event) {
            const self = event.data;
            setTimeout(function () {
                $('[data-fd-control=toggle]', self.element).control_toggle('destroy').control_toggle();
                $('[data-fd-control=select]', self.element).trigger('change');
                $('[data-fd-control=imagefile]', self.element).control_imagefile('reset');
                if (!("ontouchstart" in document.documentElement)) {
                    $("input:visible,textarea:visible,select:visible", self.element).first().focus();
                }

                // Clear current errors.
                const validator = self.element.validate();
                $(":input", self.element).each(function () {
                    validator.successList.push(this);
                });
                validator.showErrors();
                validator.resetForm();
                validator.reset();
            }, 1);
        },
        _setEvents: function () {
            const $self = this.element;
            $self.off('submit.fdcontrol reset.fdcontrol')
                .on('submit.fdcontrol', null, this, this._handleSubmit)
                .on('reset.fdcontrol', null, this, this._handleReset);

            if (this.options.onchange || !$self.is('form')) {
                $self.off('change.fdformcontrol')
                    .on('change.fdformcontrol', ':input', this, this._handleChange);
            }
        },
        _setOption: function (key, value) {
            this.options[key] = value;
        },
        setClean: function () {
            this.form.removeClass('dirty force-dirty').dirtyForms('setClean');
        },
        valid: function () {
            const $self = this.element;

            if (this.element.is('form')) {
                return this.element.valid();
            }

            let inputsAreValid = true;
            this.element.find('[name][name!=""]:input').filter(function () {
                return $(this).closest('[data-fd-control=form]')[0] === $self[0];
            }).each(function () {
                const $input = $(this);
                const $validationElement = $input.add($input.next('[data-valmsg-for]'));
                $.validator.unobtrusive.parse($validationElement.wrapAll('<form></form>').parent().first());
                inputsAreValid = $input.parent().valid() && inputsAreValid;
                $validationElement.unwrap();
            });
            return inputsAreValid;
        },
        rebuildValidate: function () {
            $.validator.unobtrusive.parse(this.element);

            var unobtrusiveValidation = this.element.data('unobtrusiveValidation');
            var validator = this.element.validate();

            $.each(unobtrusiveValidation.options.rules, function (elname, elrules) {
                if (validator.settings.rules[elname] === undefined) {
                    var args = {};
                    $.extend(args, elrules);
                    args.messages = unobtrusiveValidation.options.messages[elname];
                    $("[name='" + elname + "']").rules("add", args);
                } else {
                    $.each(elrules, function (rulename, data) {
                        if (validator.settings.rules[elname][rulename] === undefined) {
                            var args = {};
                            args[rulename] = data;
                            args.messages = unobtrusiveValidation.options.messages[elname][rulename];
                            $("[name='" + elname + "']").rules("add", args);
                        }
                    });
                }
            });
        },
        serialize: function () {
            const $self = this.element;

            if (this.element.is('form')) {
                return this.element.serialize();
            }

            return this.element.find('[name][name!=""]:input').filter(function () {
                return $(this).closest('[data-fd-control=form]')[0] === $self[0];
            }).serialize();
        },
        reset: function () {
            // This will reset the controlls of a form to the default page-load state. If called on a non-form it will rest all child forms but not affect input's not contained in a form.
            if (!this.element.is('form')) {
                $("form[data-fd-control=form]", this.element).control_form('reset');
            } else {
                this.element.trigger("reset");
            }
        },
        popTriggerElement: function () {
            const triggerElement = this.getTriggerElement();
            this._triggerElement = undefined;
            return triggerElement;
        },
        getTriggerElement: function () {
            return this._triggerElement || $();
        }
    });
}(jQuery));